import { useState, useEffect } from 'react';

// Throttle function
const throttle = (func, delay) => {
  let lastCall = 0;
  return (...args) => {
    const now = new Date().getTime();
    if (now - lastCall >= delay) {
      lastCall = now;
      func(...args);
    }
  };
};

const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState(() => {
    const width = window.innerWidth;
    return width < 768 ? 'mobile' : width < 1300 ? 'tablet' : 'desktop';
  });

  useEffect(() => {
    const updateDeviceType = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setDeviceType('mobile');
      } else if (width < 1300) {
        setDeviceType('tablet');
      } else {
        setDeviceType('desktop');
      }
    };

    // Throttle the device type update to avoid rapid changes
    const throttledUpdateDeviceType = throttle(updateDeviceType, 200);

    // Create a ResizeObserver instance
    const resizeObserver = new ResizeObserver(() => {
      throttledUpdateDeviceType();
    });

    // Observe the document body or main container for size changes
    resizeObserver.observe(document.body);

    // Set initial state
    updateDeviceType();

    return () => {
      resizeObserver.disconnect(); // Clean up observer
    };
  }, []);

  return deviceType;
};

export default useDeviceType;